import { OptionsFilter } from 'projects/access-control/src/app/Domain/Entities/filter-list.interface';
import {
	Component,
	EventEmitter,
	Input,
	OnChanges,
	OnInit,
	Output,
	SimpleChanges,
} from '@angular/core';
import { TranslateService } from '@mangosoft/mango-layout';
import { MenuItem } from 'primeng/api';
import { Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';

@Component({
	selector: 'app-filter',
	templateUrl: './filter.component.html',
	styleUrls: ['./filter.component.scss'],
})
export class FilterComponent implements OnInit, OnChanges {
	@Input() options: OptionsFilter[] = [
		{ value: 'path', label: 'Path' },
		{ value: 'name', label: 'Name' },
	];
	@Input() widh: number = 650;
	@Output() filterSelected = new EventEmitter<OptionsFilter[]>();
	selectable = true;
	removable = true;
	addOnBlur = true;
	activeOptions = false;
	unsubscribe$ = new Subject();
	chips: OptionsFilter[] = [];
	data = '';
	placeholder = 'Search';
	items: MenuItem[] = [
		{
			label: 'Nombre',
			command: () => {},
		},
		{
			label: 'Path',
			command: () => {},
		},
		{
			label: 'Ruta',
			command: () => {},
		},
	];
	constructor(private translateService: TranslateService) {}

	ngOnInit(): void {
		this.applyItem();
		this.getTranslate();
	}

	getTranslate() {
		this.translateService
			.init('AccessControl')
			.pipe(
				tap((data) => {
					this.placeholder = data.components.subSidebar.search;
				}),
				takeUntil(this.unsubscribe$)
			)
			.subscribe();
	}
	ngOnChanges(changes: SimpleChanges): void {
		this.applyItem();
	}

	applyItem() {
		this.items = this.options.map((option) => {
			return {
				label: option.label,
				command: () => {
					this.activeFilter(option);
				},
			};
		});
	}

	viewOptions() {
		this.activeOptions = !this.activeOptions;
	}
	activeFilter(option: OptionsFilter) {
		this.chips = this.chips.filter((dat) => dat.name !== option.name);
		if (this.data.length !== 0) {
			this.chips.push({ ...option, selected: this.data });
			this.filterSelected.emit(this.chips);
		}
		this.data = '';
	}
	removeItem(item: OptionsFilter) {
		this.chips = this.chips.filter((itemChip) => itemChip.name !== item.name);
		this.filterSelected.emit(this.chips);
	}

	calcWidth() {
		return { width: `calc(100vw - ${this.widh}px) ` };
	}
}
